import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "../../lib/api";
import PremiumLayout from "./PremiumLayout";
import PhotoCarousel from "./PhotoCarousel";

function money(n) {
  const v = Number(n) || 0;
  if (v >= 10_000_000) return `₹${(v / 10_000_000).toFixed(2)} Cr`;
  if (v >= 100_000)    return `₹${(v / 100_000).toFixed(2)} L`;
  return `₹${v.toLocaleString("en-IN")}`;
}

export default function PremiumProperties() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    http.get("/marketing/site").then(({ data }) => setItems(data.properties || [])).catch(() => {});
  }, []);

  return (
    <PremiumLayout>
      {/* Header */}
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 pb-8" data-testid="premium-properties-header">
        <div className="gold text-[11px] tracking-[.16em] uppercase">Properties for Sale</div>
        <h1 className="text-5xl md:text-7xl leading-[1.02] mt-4">
          Homes that are <span className="gold italic">move-in ready.</span>
        </h1>
        <p className="mt-6 max-w-2xl text-[#B8B0A0] text-lg leading-relaxed">
          A curated set of finished properties built by our studio and currently on the market —
          each one photographed, priced, and ready for a walk-through.
        </p>
      </section>

      {/* Grid */}
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-14">
        {items.length === 0 ? (
          <div className="py-32 text-center text-[#7A7267]">No properties currently listed.</div>
        ) : (
          <div className="grid md:grid-cols-2 gap-8" data-testid="premium-properties-grid">
            {items.map((p) => <PropertyCard key={p.id} p={p} />)}
          </div>
        )}
      </section>
    </PremiumLayout>
  );
}

function PropertyCard({ p }) {
  const photos = (p.photos && p.photos.length > 0) ? p.photos : [
    "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=1400&auto=format&fit=crop&q=80"
  ];
  return (
    <Link to={`/properties/${p.id}`}
          className="group block border border-[#1F1F1F] overflow-hidden bg-[#0F0F0F] hover:border-[#C9A96E] transition-colors"
          data-testid={`property-card-${p.id}`}>
      <div className="relative aspect-[4/3] overflow-hidden">
        <PhotoCarousel photos={photos} interval={5000} alt={p.title} className="w-full h-full" />
        <div className="absolute top-4 left-4 gold bg-[#0A0A0A]/85 border border-[#C9A96E] px-3 py-1 text-[11px] tracking-[.16em] uppercase z-10">
          {p.status || "Available"}
        </div>
      </div>
      <div className="p-7">
        <div className="text-[11px] tracking-[.16em] uppercase text-[#9A9284]">{p.location || "—"}</div>
        <div className="text-3xl mt-3 leading-tight">{p.title}</div>
        {/* Price + Area — identical color, font, height */}
        <div className="mt-5 flex items-baseline gap-8 flex-wrap" data-testid={`price-area-${p.id}`}>
          <div className="gold text-2xl" style={{ lineHeight: 1 }}>{money(p.price)}</div>
          <div className="gold text-2xl" style={{ lineHeight: 1 }}>
            {p.area_sqft ? `${p.area_sqft.toLocaleString("en-IN")} sqft` : "—"}
          </div>
        </div>
        {p.description && <p className="mt-5 text-[#DDD5C4] leading-relaxed text-sm line-clamp-3">{p.description}</p>}
        <div className="mt-6 pt-5 border-t border-[#1F1F1F] flex items-center justify-between">
          <div className="text-sm text-[#B8B0A0]">Enquire: <span className="cream">{p.contact || "+91 90000 00000"}</span></div>
          <span className="gold text-sm">View details →</span>
        </div>
      </div>
    </Link>
  );
}
